function n(){for(var n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];var o=n.filter(Boolean);return o.length<=1?o[0]||null:function(n){o.forEach((function(t){"function"==typeof t?t(n):t&&(t.current=n)}))}}export{n as default};
//# sourceMappingURL=index.js.map
